import React from 'react';
//scss
import './ProjectC.scss';
//icons
import Leaf from '../Icons/leaf';

class ProjectC extends React.Component {
  constructor() {
    super();
    this.backgroundRef = React.createRef();
    this.underlineRef = React.createRef();
  }
  onHoverOn = () => {
    const isFirefox = typeof InstallTrigger !== 'undefined';
    if (isFirefox === false) {
      const background = this.backgroundRef.current;
      background.classList.toggle('background_hover');
    }
    const underline = this.underlineRef.current;
    underline.classList.toggle('underline_hover');
  };

  onHoverOut = () => {
    const isFirefox = typeof InstallTrigger !== 'undefined';
    if (isFirefox === false) {
      const background = this.backgroundRef.current;
      background.classList.toggle('background_hover');
    }
    const underline = this.underlineRef.current;
    underline.classList.toggle('underline_hover');
  };
  render() {
    return (
      <div className="ProjectC">
        <div className="ProjectC_background" ref={this.backgroundRef}></div>
        <div
          className="ProjectC_content"
          onMouseEnter={this.onHoverOn}
          onMouseLeave={this.onHoverOut}
        >
          <div className="ProjectC_content_Text">
            <div className="ProjectC_content_Text_title">
              POTHOS
              <div
                className="ProjectC_content_Text_title_underline"
                ref={this.underlineRef}
              ></div>
            </div>
            <div className="ProjectC_content_Text_description">
              Botanical e-commerce site <span>(OFFLINE)</span>
            </div>
          </div>
          <Leaf />
        </div>
      </div>
    );
  }
}

export default ProjectC;
